import type { instantiate as vmInstantiate } from '../../dist/wasm/vm-dev.d.ts'

import { envTypes } from './env-types'
import { getMemoryView } from './memory-view'
import { wasmSourceMap } from './wasm-sourcemap'

export type Resolved<T> = T extends Promise<infer U> ? U : never
export type VmInstance = Resolved<ReturnType<typeof vmInstantiate>> & Record<string, any>
export type Vm = Resolved<ReturnType<typeof initVm>>

export async function fetchBinary(dev = location.href.includes('test')) {
  const filename = 'vm-' + (dev ? 'dev.wasm' : 'prod.wasm')

  const binaryRes = await fetch(
    new URL('../../dist/wasm/' + filename, import.meta.url).href
  )

  let buffer = await binaryRes.arrayBuffer()

  if (dev) {
    const absoluteUrl = new URL('../../dist/wasm/' + filename + '.map', import.meta.url).href
    buffer = wasmSourceMap.setSourceMapURL(buffer, absoluteUrl)
  }

  const binary = new Uint8Array(
    new SharedArrayBuffer(buffer.byteLength)
  )

  binary.set(new Uint8Array(buffer))

  return binary
}

export async function initVm(binary: Uint8Array, memory: WebAssembly.Memory) {
  const view = getMemoryView(memory)

  function abort(messagePtr: number, filenamePtr: number, line: number, col: number) {
    const message = view.readString(messagePtr >>> 0)
    const filename = view.readString(filenamePtr >>> 0)
    line = line >>> 0
    col = col >>> 0
    throw Error(`${message} in ${filename}:${line}:${col}`)
  }

  function log(x: number) {
    console.log('[vm]', x)
  }

  const wasm = await WebAssembly.instantiate(
    binary,
    {
      env: {
        memory,
        abort,
        logi: log,
        logf: log,
        logd: log,
      }
    }
  )

  const instance = wasm.instance.exports as VmInstance

  const exports = Object.fromEntries(
    Object.entries(envTypes)
      .map(([k]) =>
        [k, instance[k]]
      )
  ) as { [K in keyof typeof envTypes]: (...args: any[]) => any }

  const Rate = {
    Audio: instance['Rate.Audio'].value as number,
    Control: instance['Rate.Control'].value as number,
  }

  return {
    Rate,
    view,
    instance,
    exports,
  }
}
